var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreningi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 954,
    height: 437,
    viewBox: "0 0 954 437",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M744.4 218.3C744.4 234.5 729.4 247.7 711 247.7H240.9C222.5 247.7 207.5 234.5 207.5 218.3C207.5 202.1 222.5 188.9 240.9 188.9H711C729.4 188.9 744.4 202.1 744.4 218.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M850.6 402.8C850.6 421.2 835.6 436.2 817.2 436.2H814.6C796.2 436.2 781.2 421.2 781.2 402.8V33.7999C781.2 15.3999 796.2 0.399902 814.6 0.399902H817.2C835.6 0.399902 850.6 15.3999 850.6 33.7999V402.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M170.7 402.8C170.7 421.2 155.7 436.2 137.3 436.2H134.7C116.3 436.2 101.3 421.2 101.3 402.8V33.7999C101.3 15.3999 116.3 0.399902 134.7 0.399902H137.3C155.7 0.399902 170.7 15.3999 170.7 33.7999V402.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M953.3 265.9C953.3 284.3 938.3 299.3 919.9 299.3C901.5 299.3 886.5 284.3 886.5 265.9V170.6C886.5 152.2 901.5 137.2 919.9 137.2C938.3 137.2 953.3 152.2 953.3 170.6V265.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M67.0998 265.9C67.0998 284.3 52.0998 299.3 33.6998 299.3C15.2998 299.3 0.299805 284.3 0.299805 265.9V170.6C0.299805 152.2 15.2998 137.2 33.6998 137.2C52.0998 137.2 67.0998 152.2 67.0998 170.6V265.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.4 390.6C303.5 390.6 297.6 390.6 291.8 390.6C290.6 390.6 289.9 390.3 289.5 389.1C285.9 377.8 282.3 366.6 278.6 355.3C278.2 354.2 278.4 353.6 279.4 352.8C289 345.9 298.6 338.9 308.2 331.9C309.1 331.2 309.7 331.2 310.6 331.9C320.3 339 330 346 339.7 353C340.6 353.6 340.8 354.2 340.4 355.1C336.7 366.5 333 377.8 329.3 389.2C329 390.3 328.4 390.5 327.4 390.5C321.4 390.5 315.4 390.5 309.4 390.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.6 396.5C246.4 396.5 246.9 396.5 247.5 396.5C259.6 396.5 271.8 396.5 283.9 396.5C285.2 396.5 285.8 396.8 286.3 398.2C290 409.8 293.8 421.4 297.6 433C297.8 433.5 297.9 433.9 298 434.6C297.5 434.7 297 434.8 296.5 434.8C284.2 434.8 271.9 434.8 259.6 434.8C258.6 434.8 257.9 434.7 257.5 433.5C253.7 421.5 249.8 409.6 245.9 397.6C245.9 397.3 245.8 397.1 245.6 396.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.1 396.6C371.5 401.6 369.9 406.5 368.3 411.4C365.9 418.7 363.6 426 361.2 433.2C360.9 434.1 360.6 434.7 359.5 434.7C347 434.7 334.5 434.7 322 434.7C321.7 434.7 321.4 434.6 320.9 434.6C321.8 431.6 322.7 428.8 323.6 426C326.6 416.7 329.7 407.3 332.7 397.9C333 396.8 333.5 396.4 334.7 396.4C347.1 396.4 359.4 396.4 371.8 396.4C372.2 396.5 372.5 396.6 373.1 396.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.6 375C236.9 369.8 235.3 364.9 233.7 359.9C231.4 352.7 229.1 345.6 226.7 338.4C226.4 337.5 226.3 336.8 227.3 336.2C237.6 328.8 247.9 321.3 258.2 313.8C258.3 313.7 258.4 313.7 258.8 313.6C262.9 326.2 267 338.7 271.1 351.4C260.2 359.3 249.5 367.1 238.6 375Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.7 300.1C337 303.5 332.6 306.7 328.2 309.9C322.3 314.2 316.5 318.4 310.6 322.7C309.8 323.3 309.2 323.6 308.3 322.9C298.2 315.5 288 308.1 277.9 300.8C277.6 300.6 277.3 300.5 276.9 300.3C282.7 296.1 288.1 292.2 293.4 288.3C298.3 284.7 303.2 281.2 308.1 277.6C308.9 277 309.4 276.7 310.4 277.4C320.7 284.9 331.1 292.4 341.7 300.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.2 313.6C367.5 318.9 374.6 324 381.6 329.1C384.8 331.4 388.1 333.8 391.3 336.2C391.8 336.6 392.2 337.6 392.1 338.1C388.3 350.1 384.3 362.1 380.4 374.1C380.3 374.3 380.2 374.5 380 374.9C374.9 371.2 369.8 367.5 364.8 363.9C359.6 360.1 354.3 356.3 349.1 352.4C348.6 352 348.1 351 348.2 350.5C352.1 338.3 356.1 326.1 360.2 313.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.1 309.9C351 322.6 346.9 335.1 342.8 347.9C333.3 341 324 334.3 314.5 327.4C325.3 319.5 336.1 311.7 346.8 303.9C349.6 305.9 352.3 307.9 355.1 309.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.2 396.6C303.7 396.6 315.1 396.6 326.9 396.6C326.1 399.2 325.3 401.6 324.5 404C321.3 413.7 318.2 423.4 315.1 433.1C314.7 434.3 314.2 434.8 312.9 434.7C310.5 434.6 308.2 434.7 305.8 434.6C305.2 434.6 304.4 434.1 304.2 433.6C300.2 421.4 296.2 409.2 292.3 397.1C292.2 397 292.2 396.9 292.2 396.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273 357.5C276.6 368.6 280.1 379.5 283.7 390.6C282.9 390.6 282.3 390.6 281.8 390.6C269.7 390.6 257.5 390.6 245.4 390.6C243.9 390.6 243.3 390.1 242.9 388.8C242.3 386.6 241.5 384.4 240.9 382.2C240.8 381.7 241 380.8 241.3 380.5C251.8 372.8 262.3 365.2 273 357.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.2 327.3C294.8 334.1 285.6 340.8 276.1 347.7C275.2 344.9 274.4 342.4 273.5 339.8C270.4 330.3 267.3 320.7 264.2 311.2C263.8 310 264 309.4 265 308.7C267.3 307.2 269.5 305.5 271.9 303.8C282.6 311.6 293.4 319.4 304.2 327.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.2 390.4C338.7 379.5 342.3 368.6 345.9 357.6C349.4 360.2 352.8 362.6 356.1 365.1C363 370.1 369.9 375.2 376.9 380.1C377.9 380.8 378.1 381.4 377.7 382.6C376.9 384.8 376.2 387.1 375.5 389.3C375.2 390.2 374.8 390.6 373.8 390.6C361.2 390.6 348.6 390.6 336 390.6C335.8 390.5 335.6 390.5 335.2 390.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.3 283.9C487.6 298.3 495.7 312.4 504 326.6C487.5 326.6 471.2 326.6 454.7 326.6C462.9 312.4 471 298.3 479.3 283.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.1 389.9C426.4 404.2 434.5 418.3 442.7 432.5C426.2 432.5 410 432.5 393.5 432.5C401.7 418.3 409.9 404.2 418.1 389.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.6 389.9C548.9 404.2 557 418.2 565.2 432.5C548.8 432.5 532.6 432.5 516.1 432.5C524.2 418.3 532.3 404.3 540.6 389.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.7 432.5C462.9 418.2 471 404.2 479.3 389.9C487.5 404.2 495.7 418.2 503.9 432.5C487.4 432.5 471.2 432.5 454.7 432.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.7 333.5C471.2 333.5 487.4 333.5 503.9 333.5C495.7 347.7 487.6 361.8 479.3 376.1C471.1 361.8 463 347.8 454.7 333.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.4 379.4C493.6 365.2 501.7 351.2 510 336.9C518.3 351.2 526.4 365.3 534.6 379.4C518.1 379.4 501.9 379.4 485.4 379.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.9 429.1C501.6 414.8 493.5 400.8 485.4 386.6C501.8 386.6 518 386.6 534.5 386.6C526.3 400.8 518.2 414.8 509.9 429.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.3 379.5C456.8 379.5 440.7 379.5 424.2 379.5C432.4 365.3 440.5 351.3 448.8 337C457 351.3 465.1 365.3 473.3 379.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.2 386.6C440.7 386.6 456.8 386.6 473.3 386.6C465.1 400.8 457 414.8 448.8 429.1C440.5 414.8 432.4 400.8 424.2 386.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M656.757 282.175L583.997 354.936L656.757 427.697L729.518 354.936L656.757 282.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M583 281.3H649.8L583 348.1V281.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M583 428.4V361.6L649.8 428.4H583Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M730.6 428.4H663.7L730.6 361.6V428.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M730.6 281.3V348.1L663.7 281.3H730.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreningi);
export default __webpack_public_path__ + "static/media/treningi.c327e76838f8baef0ed5445664881e04.svg";
export { ForwardRef as ReactComponent };